import { CommonModule, JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@ddt-web/common';
import { DomService } from '@ddt-web/dom';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { DebugQueryParamKey, UrlModule, UrlUtils } from '@ddt-web/url';
import { UserDataService, UserProfile } from '@ddt-web/user-data';
import { map, take } from 'rxjs/operators';

import { AudienceService } from '../../services/audience.service';
import { AudienceMockBannerComponent } from './audience-mock-banner.component';

@NgModule({
	declarations: [AudienceMockBannerComponent],
	imports: [CommonModule, SharedModule, UrlModule, FormsModule],
	exports: [AudienceMockBannerComponent],
	providers: [AudienceService, JsonPipe]
})
export class AudienceMockBannerModule {
	constructor(private domService: DomService, private userDataService: UserDataService) {
		const parsedUrl = new URL(window.location.href);
		this.userDataService.getUserProfile().pipe(
			take(1),
			map((userProfile: UserProfile) => userProfile?.internalUser)
		).subscribe((isInternalUser: boolean) => {
			if (!UrlUtils.isProdDmz() && isInternalUser && (parsedUrl.searchParams.get(DebugQueryParamKey.MOCK_COUNTRY) || localStorage.getItem(LocalStorageKey.MockCountry))) {
				this.domService.prependComponentToBody(AudienceMockBannerComponent);
			}
		});
	}
}
